import { render, staticRenderFns } from "./FieldKeyValueObject.vue?vue&type=template&id=c51f07d2&scoped=true&"
import script from "./FieldKeyValueObject.vue?vue&type=script&lang=js&"
export * from "./FieldKeyValueObject.vue?vue&type=script&lang=js&"
import style0 from "./FieldKeyValueObject.vue?vue&type=style&index=0&id=c51f07d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51f07d2",
  null
  
)

export default component.exports